import * as React from "react";
import * as ReactDOM from "react-dom";
import { FC, useEffect, useState } from "react";
import { Control } from "ol/control";

export const Compass: FC<{ this: Control; title: string }> = (props) => {
    const [rotation, setRotation] = useState(0);
    const map = props.this.getMap();
    const view = map.getView();
    let center: number[];
    let lastAngle: number;

    useEffect(() => {
        view.on("change:rotation", (e) => {
            const degrees = Math.round((e.oldValue * 180) / Math.PI);
            setRotation(degrees);
        });
        map.on("contextmenu", (e) => {
            e.preventDefault();
        });
        map.on("pointerdown", (e) => {
            if (e.originalEvent.button === 2) {
                center = getCenter();
                lastAngle = undefined;
                map.on("pointermove", rotateView);
            }
        });
        map.on("pointerup", (e) => {
            if (e.originalEvent.button === 2) {
                map.un("pointermove", rotateView);
            }
        });
    }, []);

    const rotateView = (e) => {
        const angle = Math.atan2(center[1] - e.pixel[1], e.pixel[0] - center[0]);
        lastAngle !== undefined && view.adjustRotation(-(angle - lastAngle));
        lastAngle = angle;
    };

    const getCenter = () => {
        const size = map.getSize();
        return [size[0] / 2, size[1] / 2];
    };

    const onClick = () => {
        map.getView().animate({ rotation: 0, duration: 500 });
    };

    return (
        <>
            <div className="rotate-button" onClick={onClick} title={props.title}>
                <span
                    className={rotation === 0 ? "icon-mammadaba-navigate-arrow-north" : "icon-mammadaba-navigate-arrow"}
                    style={{ transform: "rotateZ(" + rotation + "deg)" }}
                />
            </div>
        </>
    );
};

export class CompassButton extends Control {
    constructor(title: string) {
        const element = document.createElement("div");
        element.className = "mammadaba-map-button rotate-container ol-unselectable ol-control";
        element.id = "compass-button";
        super({
            element
        });
        ReactDOM.render(<Compass this={this} title={title} />, element);
    }
}
